<template>
  <de-layout-content>
    <el-card>
      <div slot="header" class="spcBt">
        <span class="cardTit">添加成员</span>
      </div>
      <div class="tab">
        <div :class="['item', key == item.key ? 'active' : '']" v-for="(item, index) in tabList" :key="index"
             @click="selectTab(item)">
          {{ item.tab }}
        </div>
      </div>

      <div class="main" style="width: 840px">
        <div class="moduleTitle">基本信息</div>
        <div class="form">
          <el-form :model="formData" label-position="top" style="width: 100%" ref="formRef" :rules="rules">
            <el-row :gutter="20" v-if="key == 9">
              <el-col :span="12">
                <el-form-item label="成员角色" prop="roleIds">
                  <el-select v-model="formData.roleIds" multiple filterable clearable placeholder="选择成员角色"
                             style="width: 100%" @change="$forceUpdate()">
                    <el-option v-for="item in rolesSelect" :key="item.id" :label="item.remark" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="姓名" prop="name">
                  <el-input v-model="formData.name" placeholder="输入姓名" maxlength="50"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="照片" prop="headImageUrl">
                  <uploadImg :ImgUrl="formData.headImageUrl" @imgCallback="(url) => imgCallback(url, 'headImageUrl')">
                  </uploadImg>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别" prop="sex">
                  <el-radio-group v-model="formData.sex">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="key != 9">
                <el-form-item label="成员角色" prop="roleIds">
                  <el-select v-model="formData.roleIds" multiple filterable clearable placeholder="选择成员角色"
                             style="width: 100%" @change="$forceUpdate()">
                    <el-option v-for="item in rolesSelect" :key="item.id" :label="item.remark" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证号">
                  <el-input v-model="formData.idCardNo" autocomplete="off" maxlength="18" @change="idInput"
                            placeholder="输入身份证号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号码" prop="phone">
                  <el-input v-model="formData.phone" autocomplete="off" maxlength="11" placeholder="输入手机号码"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生日" prop="birthday">
                  <el-date-picker v-model="formData.birthday" type="date" placeholder="输入出生日期" style="width: 100%">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所在部门" prop="organizationId">
                  <el-cascader ref="cascaderGroup" style="width: 100%" v-model="formData.organizationId"
                               placeholder="选择所在部门"
                               :props="{ multiple: true, checkStrictly: true, value: 'keyId', label: 'name', children: 'sonOrganizationVoList' }"
                               :options="departmentOption" @change="handleCascaderChange"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="入队时间" prop="workingTime">
                  <el-date-picker v-model="formData.workingTime" type="date" placeholder="选择入队时间" style="width: 100%">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="年龄">
                  <el-input v-model="formData.age" placeholder="输入年龄" maxlength="100"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="直接上级">
                  <el-input v-model="userName" ref="memberInput" placeholder="选择直接上级" @focus="selectMember" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职务">
                  <el-select v-model="formData.postId" clearable filterable placeholder="选择职务" style="width: 100%">
                    <el-option v-for="pos in positionOptions" :key="pos.postId" :label="pos.postName"
                               :value="pos.postId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <template v-if="key == 2">
                <el-col :span="12">
                  <el-form-item label="政治面貌">
                    <el-select v-model="formData.politicalAffiliation" clearable placeholder="选择政治面貌务"
                               style="width: 100%">
                      <el-option v-for="item in politicalAffiliationOptions" :key="item.id" :label="item.name"
                                 :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="民族">
                    <el-input v-model="formData.ethnicGroup" placeholder="输入民族" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="专业">
                    <el-input v-model="formData.professional" placeholder="输入专业" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="毕业院校">
                    <el-input v-model="formData.schoolName" placeholder="输入毕业院校" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="籍贯所在地">
                    <el-input v-model="formData.nativePlace" placeholder="输入籍贯所在地" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="学历">
                    <el-input v-model="formData.educationalBackground" placeholder="输入学历" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="是否两库人员" prop="doubleLibrary">
                    <el-radio-group v-model="formData.doubleLibrary">
                      <el-radio :label="2">是</el-radio>
                      <el-radio :label="1">否</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </template>
              <el-col :span="12">
                <el-form-item label="状态">
                  <el-switch v-model="formData.status" :active-value="1" :inactive-value="-1"></el-switch>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注">
                  <el-input v-model="formData.remark" type="textarea" :autosize="{ minRows: 5 }" autocomplete="off"
                            placeholder="输入备注" maxlength="100" show-word-limit></el-input>
                </el-form-item>
              </el-col>
              <template v-if="key == 2">
                <el-col>
                  <div class="moduleTitle">训练信息</div>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="运动项目" prop="trainingProjectId">
                    <el-select v-model="formData.trainingProjectId" placeholder="运动项目" style="width: 100%">
                      <el-option v-for="item in objTypes" :key="item.id" :label="item.projectName"
                                 :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="集训时间">
                    <el-date-picker v-model="formData.trainingCampTime" type="date" placeholder="选择集训时间"
                                    style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="试训时间">
                    <el-date-picker v-model="formData.practicalTrainingTime" type="date" placeholder="选择试训时间"
                                    style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="转正时间">
                    <el-date-picker v-model="formData.employeeTime" type="date" placeholder="选择转正时间" style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="运动等级" prop="sportsLevel">
                    <el-select v-model="formData.sportLevel" placeholder="选择运动等级" style="width: 100%">
                      <el-option v-for="(item, index) in LevelList" :key="index" :label="item.name" :value="item.name">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="输送教练">
                    <el-input v-model="formData.transportCoach" placeholder="输入输送教练" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="输送单位">
                    <el-input v-model="formData.conveyingUnit" placeholder="输入输送单位" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="房间号">
                    <el-input v-model="formData.roomNo" placeholder="输入房间号" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="个人简历">
                    <el-input v-model="formData.establish" type="textarea" :autosize="{ minRows: 5 }" autocomplete="off"
                              placeholder="输入个人简历" maxlength="500" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="运动成绩">
                    <el-input v-model="formData.sportsPerformance" type="textarea" :autosize="{ minRows: 5 }"
                              autocomplete="off" placeholder="输入运动成绩" maxlength="500" show-word-limit></el-input>
                  </el-form-item>
                </el-col>
                <el-col>
                  <div class="moduleTitle">家庭成员信息</div>
                </el-col>
                <div style="width: 100%;display: flex;flex-direction: row;gap: 20px"
                     v-for="(item, index) in formData.familieList">
                  <div style="width: 25%;">
                    <el-form-item label="姓名">
                      <el-input v-model="item.name" autocomplete="off" placeholder="输入姓名" maxlength="100"></el-input>
                    </el-form-item>
                  </div>
                  <div style="width: 25%;">
                    <el-form-item label="联系方式">
                      <el-input v-model="item.phone" autocomplete="off" maxlength="11" placeholder="输入联系方式"></el-input>
                    </el-form-item>
                  </div>
                  <div style="width: 25%;">
                    <el-form-item label="出生年月">
                      <el-date-picker v-model="item.time" type="date" placeholder="选择出生年月" style="width: 100%"></el-date-picker>
                    </el-form-item>
                  </div>
                  <div style="width: 25%;">
                    <el-form-item label="工作单位">
                      <div class="parentsView">
                        <el-input v-model="item.work" autocomplete="off" placeholder="输入工作单位"
                                  maxlength="100"></el-input>
                        <i class="el-icon-circle-close delBtn" :class="index == 0 ? 'disable' : ''"
                           @click="formData.familieList.splice(index, 1)"></i>
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <el-col :span="24">
                  <el-form-item>
                    <div style="display: flex;justify-content: center">
                      <el-button icon="el-icon-plus" plain type="primary" @click="addParent">增加一行</el-button>
                    </div>
                  </el-form-item>
                </el-col>
              </template>
              <el-col>
                <el-form-item>
                  <div style="display: flex;justify-content: flex-end">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="onSubmit('formRef')">提交</el-button>
                    <el-button @click="resetForm('formRef')">重置</el-button>
                  </div>
                </el-form-item>
              </el-col>
              <memberTree :keys="checkedKeys" :peoples="whoMemberData" :dataList="memberList" :modalTitle="'选择直接上级'"
                          :modalVisible="memberTreeVisible" :mpl="false" @transmit="getMemberRes"></memberTree>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-card>
  </de-layout-content>
</template>

<script>
import * as API_User from "@/api/system/user";
import * as API_Member from "@/api/member/member";
import moment from "moment";
import "moment/locale/zh-cn";
import uploadImg from "@/components/uploadImg/uploadImg.vue";
import AdministrativeArea from "@/components/administrativeArea/administrativeArea.vue";
import { getDepartmentList } from "@/api/team";
import * as API_System from "@/api/train/system";
import memberTree from "@/views/sportCenter/components/memberTree.vue";
import { getPositionListAll } from "@/api/position";
import { checkPermission } from "@/utils/permission";
import { getPoliticalSelectList } from "@/api/train/system";
import { getSportProjectSelectList } from "@/api/train/action";
let checkPhone = async (rule, value) => {
  if (!value) {
    return Promise.reject("此号码做为登录账号，请务必填写正确");
  }
  // console.log(/^1[3456789]\d{9}$/.test(value));
  if (!/^1[3456789]\d{9}$/.test(value)) {
    return Promise.reject("请输入正确的手机号码格式");
  } else {
    return Promise.resolve();
  }
};
export default {
  components: {
    memberTree,
    uploadImg,
    AdministrativeArea,
  },
  data() {
    return {
      userName: '',
      countDown: "",
      isSend: false,
      yearPickShow: false,
      yearPickShow1: false,
      isRangeOpen: false,
      sendText: "获取验证码",
      key: 2,
      selectIndex: 0,
      tabList: [
        // { key: 1, tab: "超级管理员", permission: 'member:Management'},
        { key: 2, tab: "运动员", permission: 'member:Athlete' },
        { key: 3, tab: "教练员", permission: 'member:Coach' },
        { key: 4, tab: "科研人员", permission: 'member:ScientificResearch' },
        { key: 5, tab: "医疗人员", permission: 'member:MedicalService' },
        { key: 8, tab: "管理人员", permission: 'member:Management' },
        { key: 9, tab: "其他", permission: 'member:Other' },
      ],
      educateData: [
        { id: 1, name: "初中及以下" },
        { id: 2, name: "中专/中技" },
        { id: 3, name: "高中" },
        { id: 4, name: "大专" },
        { id: 5, name: "本科" },
      ],
      objTypes: [],
      departmentOption: [],
      formData: {
        isAddUser: 1,
        type: 2,
        name: null,
        headImageUrl: null,
        sex: 1,
        roleIds: null,
        idCardNo: null,
        phone: null,
        birthday: null,
        organizationId: null,
        workingTime: null,
        age: null,
        position: null,
        politicalAffiliation: null,
        ethnicGroup: null,
        professional: null,
        schoolName: null,
        nativePlace: null,
        educationalBackground: null,
        userIds: null,
        trainingProjectId: null,
        trainingCampTime: null,
        practicalTrainingTime: null,
        employeeTime: null,
        sportLevel: null,
        transportCoach: null,
        conveyingUnit: null,
        roomNo: null,
        establish: null,
        sportsPerformance: null,
        status: 1,
        remark: '',
        familieList: [
          {
            name: null,
            time: null,
            phone: null,
            work: null
          }
        ],
        doubleLibrary: 1
      },
      rules: {
        headImageUrl: [{ required: true, message: "请上传照片", trigger: "change", },],
        name: [{ required: true, message: "请填写姓名", trigger: "blur", },],
        roleIds: [{ required: true, message: "请选择成员角色", trigger: "blur", },],
        sex: [{ required: true, message: "请填写性别", trigger: "change", },],
        phone: [{ required: true, validator: checkPhone, trigger: "blur", },],
        // idCardNo: [
        //   { required: true, message: "请输入身份证号码", trigger: "blur" },
        //   { pattern: /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/, message: '身份证号格式不正确', trigger: 'blur' }
        // ],
        organizationId: [{ required: true, message: "请选择所在部门", trigger: "change", }],
        trainingProjectId: [{ required: true, message: "请选运动项目", trigger: "change", }],
        doubleLibrary: [{ required: true, message: "请选择是否为两库人员", trigger: "change", }],
      },
      sectionCascaderProps: {
        label: "name",
        value: "id",
        children: "children",
      },
      cascaderProps: {
        label: "name",
        value: "name",
        children: "child",
      },
      teachesInfo: {
        show: false,
        type: 1, // 1-添加 2-编辑
        id: null,
        index: null,
        companyName: null, // 公司名称
        position: null, // 职位
        teachingContent: null, // 执教内容
        teachingTime: null, // 执教时间
        teachingTimeValue: null, // 执教时间
      },
      educationsInfo: {
        show: false, // 显示弹框
        type: 1, // 1-添加 2-编辑
        collegeName: null, // 学校名称
        degree: null, // 学历
        educationTime: null, // 教育时间
        major: null, // 专业
        startTime: null,
        endTime: null,
      },
      trainingProjectList: [{ trainingProject: null, options: null }],
      areaSource: [],
      centerList: [],
      sectionOptions: [],
      positionSelectList: [],
      sportItemData: [],
      LevelList: [],
      educationsList: [],
      teachesList: [],
      rolesSelect: [],
      checkedKeys: [],
      whoMemberData: [],
      memberList: [],
      memberTreeVisible: false,
      positionOptions: [],
      politicalAffiliationOptions: [],
      firstLevelId: null,
    };
  },
  created() {
    this.init();
    this.getLevelSelectList();
    this.getPoliticalSelectList();
    this._getProjectList()
  },
  mounted() { },
  methods: {
    checkPermission,
    init() {
      this._getDepartmentList()
      this._allRoles(2)
    },
    _getProjectList() {
      getSportProjectSelectList({}).then(res => {
        this.objTypes = res
      })
    },
    _getPositionListAll(organizationId) {
      getPositionListAll({organizationId: organizationId.replace('o','')}).then(res => {
        if (res.code == 200) {
          this.positionOptions = res.data
        }
      })
    },
    _allRoles(type) {
      API_User.allRoles({ roleType: type }).then(res => {
        if (res.success) {
          this.rolesSelect = res.data
          this.formData.roleIds = null
        }
      })
    },
    selectTab(item) {
      this.$refs.formRef.resetFields()
      this.$nextTick(() => {
        this.key = item.key
        this.formData.type = item.key;
        this.formData.roleIds = null
        this._allRoles(this.key)
      })

    },
    _getDepartmentList() {
      getDepartmentList({}).then(res => {
        if (res.code == 200) {
          this.departmentOption = res.data
          let ids = this.getPathIfOnlyOneLeaf(res.data)
          this.formData.organizationId = ids ? [ids] : []
        }
      })
    },
    getPathIfOnlyOneLeaf(nodes) {
      if (!Array.isArray(nodes) || nodes.length === 0) {
        return false; // 空列表无叶子
      }

      let leafPath = null;      // 存储找到的第一个叶子的完整路径
      let multipleLeaves = false; // 标记是否发现多个叶子

      // 深度优先遍历单个节点，记录当前路径（不包括当前节点 keyid）
      function dfs(node, pathSoFar) {
        // 判断是否为叶子（无 children 或 children 为空）
        const isLeaf = !node.sonOrganizationVoList || node.sonOrganizationVoList.length === 0;

        if (isLeaf) {
          if (leafPath === null) {
            // 记录第一个叶子的路径：路径 + 当前节点 keyid
            leafPath = [...pathSoFar, node.keyId];
          } else {
            multipleLeaves = true; // 发现第二个叶子
          }
          return;
        }

        // 非叶子：继续遍历子节点，路径中加入当前节点 keyid
        for (const child of node.sonOrganizationVoList) {
          if (multipleLeaves) return; // 提前终止
          dfs(child, [...pathSoFar, node.keyId]);
        }
      }

      // 遍历所有根节点
      for (const root of nodes) {
        if (multipleLeaves) break;
        dfs(root, []);
      }

      return multipleLeaves ? false : leafPath;
    },
    _getMemberTree() {
      let params = { notTypeStr: 2 };
      if (this.checkedKeys.length > 0) {
        params.userIds = this.checkedKeys;
      }
      API_Member.getMemberTree(params).then(res => {
        if (res.code == 200) {
          let { data } = res
          this.memberList = data
          this.memberTreeVisible = true
          if (this.$refs.memberInput) {
            this.$refs.memberInput.blur();
          }
        }
      });
    },
    idInput(e) {
      let regex = /^[1-9]\d{5}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/
      if (regex.test(e)) {
        const reg = /^(\d{6})(\d{4})(\d{2})(\d{2})/;
        const match = e.match(reg);
        if (e.length == 18) {
          const birthYear = +e.substring(6, 10);
          const currentYear = new Date().getFullYear();
          this.$set(this.formData, 'age', currentYear - birthYear)
          this.$set(this.formData, 'birthday', `${match[2]}.${match[3]}.${match[4]}`)
        }
      }
    },
    imgCallback(imgUrl, key) {
      this.$nextTick(() => {
        this.$set(this.formData, "headImageUrl", imgUrl);
      });
    },
    getPoliticalSelectList() {
      API_System.getPoliticalSelectList().then(res => {
        if (res.code == 200) {
          this.politicalAffiliationOptions = res.data
        }
      })
    },
    // 接口-运动员等级
    getLevelSelectList() {
      API_System.getLevelSelectList().then((res) => {
        // console.log(res);
        if (res.code == 200) {
          this.LevelList = res.data;
        }
      });
    },
    handleCascaderChange(val) {
      if (!val || val.length === 0) {
        this.firstLevelId = null;
        return;
      }

      const currentFirstLevelId = val[0][0];

      if (this.firstLevelId === null) {
        this.firstLevelId = currentFirstLevelId;
        
        this._getPositionListAll(this.firstLevelId)
      }

      const filtered = val.filter(path => path[0] === this.firstLevelId);

      if (filtered.length !== val.length) {
        this.formData.organizationId = filtered;
        this.$message.warning('只能选择同一机构下的部门');
      }
    },
    toIdListName(id, list, key = "name") {
      for (let i = 0; i < list.length; i++) {
        if (list[i].id == id) {
          return list[i][key];
        }
      }
    },
    cancel() {
      this.$router.back()
    },
    onSubmit(formName) {
      // console.log(this.formData, "formData");
      this.$refs[formName]
        .validate()
        .then(() => {
          // let achieves = {
          //   remark: null,
          //   sportPerformance: this.formData.sportPerformance || null,
          //   sportsLevel: this.formData.sportsLevel || null
          // }; // 个人成绩-运动员
          let educations = this.educationsList; // 教育经历-教练|科研人员
          let teaches = this.teachesList; // 执教经历-教练|科研人员
          let usersGroupList = []
          let organizationId = JSON.parse(JSON.stringify(this.formData)).organizationId;
          let data = {};
          if (this.key == 2) {
            data = {
              ...JSON.parse(JSON.stringify(this.formData)),
              birthday: moment(this.formData.birthday).valueOf(),
              workingTime: moment(this.formData.workingTime).valueOf(),
              trainingCampTime: moment(this.formData.trainingCampTime).valueOf(),
              practicalTrainingTime: moment(this.formData.practicalTrainingTime).valueOf(),
              employeeTime: moment(this.formData.employeeTime).valueOf(),
            };
            // delete data.sportPerformance
            // delete data.sportsLevel
            delete data.organizationId
            data.familieList.forEach(item => {
              item.time = moment(item.time).valueOf()
            })
          } else {
            data = {
              isAddUser: this.formData.isAddUser,
              type: this.formData.type,
              name: this.formData.name,
              headImageUrl: this.formData.headImageUrl,
              sex: this.formData.sex,
              roleIds: this.formData.roleIds,
              userIds: this.formData.userIds,
              idCardNo: this.formData.idCardNo,
              phone: this.formData.phone,
              birthday: moment(this.formData.birthday).valueOf(),
              workingTime: moment(this.formData.workingTime).valueOf(),
              age: this.formData.age,
              postId: this.formData.postId,
              status: this.formData.status,
              remark: this.formData.remark,
            };
          }
          organizationId.forEach(item => {
            let groupObj = {
              organizationId: null,
              teamId: null,
              groupId: null,
            }
            item.forEach(iitem => {
              if (iitem[0] == 'o') {
                groupObj.organizationId = Number(iitem.substring(1, iitem.length))
              }
              if (iitem[0] == 't') {
                groupObj.teamId = Number(iitem.substring(1, iitem.length))
              }
              if (iitem[0] == 'g') {
                groupObj.groupId = Number(iitem.substring(1, iitem.length))
              }
            })
            usersGroupList.push(groupObj)
          })
          data.usersGroupList = usersGroupList
          API_Member.memberAdd(data).then((res) => {
            // console.log(res);
            if (res.code === 200) {
              this.$message.success(res.msg);
              this.$router.back()
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    resetForm() {
      this.$nextTick(() => {
        this.$refs.formRef.resetFields();
      })
    },
    addParent() {
      this.formData.familieList.push(
        {
          name: null,
          time: null,
          phone: null,
          work: null
        }
      )
    },
    selectMember() {
      this._getMemberTree()
    },

    getMemberRes(res) {
      if (Array.isArray(res)) {
        this.checkedKeys = res.map((i) => {
          return i.id;
        });
        this.formData.userIds = this.checkedKeys
        this.userName = res.map((i) => {
          return i.userName;
        }).join('，');
      }
      console.log(this.checkedKeys);
      // this.$set(this.formDtate,'joinUserIds',this.memberKeys)
      this.memberTreeVisible = false;
    },
  },
  filters: {
    momentToStr(value) {
      return moment(value).format("YYYY");
    },
    momentToStr1(value) {
      return moment(value).format("YYYY-MM");
    },
  },
  computed: {
  },
};
</script>

<style scoped lang="less">
//.tab {
//  display: flex;
//
//  .item {
//    width: 180px;
//    height: 40px;
//    line-height: 40px;
//    text-align: center;
//    border-radius: 6px;
//    border: 1px solid #f2f2f2;
//    margin-right: 32px;
//    cursor: pointer;
//  }
//
//  .active {
//    border-color: #1890FF;
//    color: #1890FF;
//  }
//}

.tab {
  display: flex;

  .item {
    width: 180px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #f2f2f2;
    margin-right: 32px;
    cursor: pointer;
  }

  .active {
    border-color: #1890FF;
    color: #1890FF;
  }
}

.main {
  .moduleTitle {
    height: 68px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
  }

  .moduleTitle::before {
    content: "▋";
    display: inline-block;
    color: #1890FF;
  }

  .addTrain {
    width: 100%;
    height: 32px;
    color: #1890FF;
    border: 1px solid #1890FF;
    text-align: center;
    line-height: 32px;
    margin-top: 22px;
    cursor: pointer;
    border-radius: 4px;

    &:hover {
      background-color: #1890FF;
      color: #fff;
    }
  }

  .moduleHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .add {
      color: #1890FF;
      cursor: pointer;
    }
  }

  .moduleContent {
    padding: 10px 15px;
    background-color: #21284b;
    border-radius: 3px;
  }

  .moduleContent .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .moduleContent .edit {
    color: #1890FF;
    cursor: pointer;
  }

  .moduleContent .bottom div {
    margin-bottom: 12px;
  }

  .parentsView {
    display: flex;
    align-items: center;

    .delBtn {
      font-size: 20px;
      margin-left: 10px;
      color: #F56C6C;
      cursor: pointer;
    }

    .disable {
      opacity: 0;
      cursor: none;
      pointer-events: none;
    }
  }
}
</style>
<style>
.el-popper.el-cascader__dropdown {
  z-index: 99999 !important;
}

.el-cascader-panel .el-cascader-menu__wrap {
  min-height: 204px !important;
}
</style>
